<template>
    <Splide :options="splideOptions" aria-label="Employee Slider" class="employees-new" tag="section" ref="splide">
        <template v-for="employee in employees">
            <SplideSlide v-if="activeEmployeesId.includes(employee.id)">
                <figure :class="config.cardClass">
                    <img :alt="employee.image_alt"
                         :src="employee.image"
                         class="img-fluid">
                    <figcaption>
                        <i :class="[config.iconInfo, styles.infoIconSize, styles.infoIconColor === 'none' ? '' : 'text-' + styles.infoIconColor]"
                           class="icon-info position-absolute"></i>
                        <i :class="[config.iconClose, styles.infoIconColor === 'none' ? '' : 'text-' + styles.infoIconColor]"
                           class="icon-close"></i>
                        <div>
                            <h4 :class="[styles.nameSizeClass, styles.nameColorClass === 'none' ? '' : 'text-' + styles.nameColorClass, config.nameClass]">
                                {{ employee.firstname }}<br>{{ employee.lastname }}
                            </h4>
                            <h6 :class="config.positionClass" class="mb-3">{{ employee.position }}</h6>
                            <div :class="config.contactClass" class="data-contact">
                                <div class="d-flex flex-column pb-4">
                                    <a v-if="employee.phone" :class="config.contactLinkClass"
                                       :href="'tel:' + employee.phone">
                                        {{ employee.phone }}
                                    </a>

                                    <a v-if="employee.mobile" :class="config.contactLinkClass"
                                       :href="'tel:' + employee.mobile">
                                        {{ employee.mobile }}
                                    </a>

                                    <a v-if="employee.email" :class="config.contactLinkClass"
                                       :href="'mailto:' + employee.email">
                                        {{ employee.email }}
                                    </a>
                                </div>
                                <div v-if="employee.icon_links.length > 0" :class="config.socialWrapper"
                                     class="social">
                                    <a v-for="iconLink in employee.icon_links" :href="iconLink.href"
                                       class="text-decoration-none mx-2" target="_blank">
                                        <i :class="[styles.someIconSize, styles.someIconColor === 'none' ? '' : 'text-' + styles.someIconColor, config.someIconClass, iconLink.icon]"></i>
                                    </a>
                                </div>

                                <div v-if="employee.vita" class="backpack-reset" v-html="employee.vita"></div>
                            </div>
                        </div>
                    </figcaption>
                </figure>
            </SplideSlide>
        </template>
    </Splide>
</template>

<script lang="ts" setup>

import {inject, ref, watch} from "vue";
import type EmployeeProvider from "../EmployeeProvider.ts";
import {Splide, SplideSlide} from '@splidejs/vue-splide';

interface Props {
    config: Object
    content: Object
    styles: Object
}

const props = defineProps<Props>();

const employeeProvider = inject<EmployeeProvider>('employeeProvider') as EmployeeProvider;

const employees = employeeProvider.getEmployees();
const activeEmployeesId = employeeProvider.getActiveEmployeesIdComputed();

const splide = ref();

watch(activeEmployeesId, () => {
    // start at first slide on filter change
    if(splide.value?.splide) {
        splide.value.splide.go(0);
    }
})

const splideOptions = {
    type: 'slide',
    perPage: 3,
    focus: 0,
    omitEnd: true,
    arrows: true,
    gap: '1.5rem',
    lazyload: 'nearby',
    breakpoints: {
        1200: {
            perPage: 2,
        },
        768: {
            perPage: 1,
            fixedWidth: '100%',
            gap: '0',
            arrows: false,
        },
    }
};

</script>
